import { motion } from 'framer-motion';
import { Mail, MapPin } from 'lucide-react';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-sm p-8"
        >
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="text-gray-600 mb-6">
              Welcome to Soft Standard Inc. ("Company," "we," "us," or "our"). Your privacy is important to us, and we are committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website www.softstandardsinc.com and use our services.
            </p>

            <p className="text-gray-600 mb-8">
              By using our website and services, you agree to the terms of this Privacy Policy. If you do not agree, please do not use our services.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Information We Collect</h2>
            <p className="text-gray-600 mb-4">We collect various types of information to provide and improve our services, including:</p>

            <h3 className="text-xl font-bold text-gray-900 mb-2">A. Personal Information</h3>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <li>Name, email address, phone number</li>
              <li>Business information (company name, website, industry)</li>
              <li>Billing and payment details (if applicable)</li>
            </ul>

            <h3 className="text-xl font-bold text-gray-900 mb-2">B. Non-Personal Information</h3>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <li>IP address, browser type, and device information</li>
              <li>Website usage data (pages visited, time spent, interactions)</li>
              <li>Cookies and tracking technologies</li>
            </ul>

            <h3 className="text-xl font-bold text-gray-900 mb-2">C. Information from Third Parties</h3>
            <ul className="list-disc list-inside text-gray-600 mb-6">
              <li>Data from advertising partners, analytics providers, or social media platforms</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. How We Use Your Information</h2>
            <p className="text-gray-600 mb-2">We use your information for the following purposes:</p>
            <ul className="list-disc list-inside text-gray-600 mb-6">
              <li>To provide and improve our digital marketing services</li>
              <li>To communicate with you about our services, promotions, and updates</li>
              <li>To personalize your experience and optimize website performance</li>
              <li>To analyze user behavior and improve our marketing strategies</li>
              <li>To comply with legal obligations and protect against fraud</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. How We Share Your Information</h2>
            <p className="text-gray-600 mb-2">We do not sell, rent, or trade your personal information. However, we may share your data with:</p>
            <ul className="list-disc list-inside text-gray-600 mb-6">
              <li>Service Providers: Third-party partners who assist with hosting, analytics, advertising, and payment processing</li>
              <li>Legal Authorities: If required by law or to protect our rights and security</li>
              <li>Business Transfers: In the event of a merger, acquisition, or sale of assets</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Cookies & Tracking Technologies</h2>
            <p className="text-gray-600 mb-6">
              We use cookies, web beacons, and similar technologies to improve user experience and analyze traffic. You can manage cookie preferences through your browser settings.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Data Security</h2>
            <p className="text-gray-600 mb-6">
              We take reasonable measures to protect your data from unauthorized access, loss, or misuse. However, no online transmission is 100% secure.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Your Rights & Choices</h2>
            <p className="text-gray-600 mb-2">You have the right to:</p>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <li>Access, update, or delete your personal information</li>
              <li>Opt out of marketing communications</li>
              <li>Request data portability</li>
              <li>Restrict or object to data processing</li>
            </ul>
            <p className="text-gray-600 mb-6">
              To exercise your rights, contact us at contact@softstandards.net.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Third-Party Links</h2>
            <p className="text-gray-600 mb-6">
              Our website may contain links to third-party websites. We are not responsible for their privacy practices. Please review their policies before sharing your information.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Changes to This Policy</h2>
            <p className="text-gray-600 mb-6">
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated date.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Contact Us</h2>
            <p className="text-gray-600 mb-4">If you have any questions about this Privacy Policy, please contact us at:</p>
            
            <div className="bg-gray-50 rounded-xl p-6 space-y-4">
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-blue-600" />
                <span className="text-gray-700">contact@softstandards.net</span>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-blue-600" />
                <span className="text-gray-700">18820B 69th AVE APT 1B New York</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}